/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import constUtil from"./util";let types=["bd","console","console-monitor","emulator","home-theatre","monitor","phone","stb","tablet","tv","workstation","unknown"];export default constUtil.deepFreeze({DEVICE_TYPE:constUtil.createEnumeration(types),DEFAULT:{MODEL:"dummyModel",FIRMWARE_VERSION:"dummyFirmwareVersion",DEVICE_YEAR:0,FIRMWARE_YEAR:0,LOCATION:"dummyLocation",COUNTRY:"dummyCountry",WIDTH:0,HEIGHT:0,RESOLUTION:{width:0,height:0}}});